var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs3":""}},[_c('v-btn',{on:{"click":_vm.emitOpenTagsDialog}},[_vm._v("Ajouter tags")])],1),_c('v-flex',{attrs:{"xs9":""}},_vm._l((_vm.tags),function(tag,index){return _c('v-chip',{key:index,staticClass:"mr-1",attrs:{"dark":""}},[_vm._v(" "+_vm._s(tag.title)+" ")])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }